import { TFunction } from 'i18next';

import { VectorImageName } from '~assets/vectors/generated';
import { StatusVariant } from '~enums';

interface BatteryThreshold {
	value: number;
	icon: VectorImageName;
	variant: StatusVariant;
	label: string;
}

const getInteractiveBatteryIconData = (value: number | undefined, t: TFunction) => {
	const thresholds: BatteryThreshold[] = [
		{
			value: 90,
			icon: 'battery/full',
			variant: StatusVariant.Neutral,
			label: t('battery_full', { ns: 'status' }),
		},
		{
			value: 60,
			icon: 'battery/middle',
			variant: StatusVariant.Neutral,
			label: t('battery_mid', { ns: 'status' }),
		},
		{
			value: 30,
			icon: 'battery/low',
			variant: StatusVariant.Warning,
			label: t('battery_low', { ns: 'status' }),
		},
		{
			value: 1,
			icon: 'battery/critical',
			variant: StatusVariant.Destructive,
			label: t('battery_critical', { ns: 'status' }),
		},
		{
			value: 0,
			icon: 'battery/critical',
			variant: StatusVariant.Neutral,
			label: t('battery_unknown', { ns: 'status' }),
		},
	];

	if (value === undefined) return thresholds[4];
	return thresholds.find((el) => value >= el.value) ?? thresholds[4];
};

export default getInteractiveBatteryIconData;
